window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.casinoGameOptimoveRepo = function () {
    var url = 'api/casinogameoptimove';

    var post = function (model) {
        return fetch(url, {
            method: 'POST',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
            body: JSON.stringify(model)
        })
        .catch(casino.repos.base.handleNetworkException);
    };

    return {
        post: post
    }

}();